
import React from 'react';
import { Button, Text, View } from "../../Components/Themed"
import type { BracketCompetitionProps, BracketProps, CompetitionPlayerBracketProps, MyPlayerProps, PlayerBracketProps } from "../../types"
import { Icons } from '../../Components';
import { useColors } from '../../constants/useColors';

type BracketHeaderProps = {
    player?:MyPlayerProps,
    active_nav:string,
    view_mode:'desktop'|'mobile',
    bracket_competition?:BracketCompetitionProps,
    bracket?:BracketProps,
    player_bracket?:PlayerBracketProps,
    competition_player_bracket?:CompetitionPlayerBracketProps,
    onGoHome:() => void
}

const BracketHeader = ({ bracket, onGoHome }:BracketHeaderProps) => {
    const Colors = useColors();
    return (
        <View style={{ flexDirection:'row', alignItems:'center', padding:10, backgroundColor:Colors.views.header }}>
            <Button float style={{ padding:10, alignItems:'center', borderRightWidth:1 }} onPress={() => onGoHome()}>
                <Icons.HomeIcon size={20} color={Colors.text.action}/>
                <Text theme='light' textAlign='center' color={Colors.text.action} style={{ marginTop:3 }}>Home</Text>
            </Button>
            <View transparent style={{ flex:1, marginLeft:10 }}>
                <Text theme='h1'>Bettor Brackets</Text>
                <View transparent style={{ flexDirection:'row', marginTop:3 }}>
                    {!bracket ?
                    <Text theme='description'>My Bracket Room</Text>
                    :
                    <Text theme='description'>Bracket / {bracket.bracket_name}</Text>
                    }
                </View>
            </View>
        </View>
    )
}

export default BracketHeader